import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-energies-page",
  templateUrl: "./energies-page.component.html",
  styleUrls: ["./energies-page.component.scss"],
})
export class EnergiesPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
